import { SimpleSelect } from '@/components/ui/select-with-more'
import type { FieldInputProps } from './fieldInputProps'
import { EARLIEST_YEAR } from './screenForm'

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

/** A month and year, not in the future, held as 'YYYY-MM' ('YYYY-' or '-MM' while half picked). */
export function MonthField({ value, onChange, id, invalid, disabled }: FieldInputProps<string>) {
  const [year = '', month = ''] = value.split('-')
  const now = new Date()
  const thisYear = now.getFullYear()
  const lastMonth = year === String(thisYear) ? now.getMonth() + 1 : 12
  const months = MONTH_NAMES.slice(0, lastMonth).map((name, index) => ({
    value: String(index + 1).padStart(2, '0'),
    label: name,
  }))
  const years = Array.from({ length: thisYear - EARLIEST_YEAR + 1 }, (_, index) => {
    const option = String(thisYear - index)
    return { value: option, label: option }
  })

  return (
    <div className="grid grid-cols-2 gap-3">
      <SimpleSelect
        id={id}
        aria-label="Month"
        options={months}
        value={month || undefined}
        onValueChange={(next) => onChange(`${year}-${next}`)}
        placeholder="Month"
        error={invalid}
        disabled={disabled}
        className="w-full"
      />
      <SimpleSelect
        aria-label="Year"
        options={years}
        value={year || undefined}
        onValueChange={(next) => {
          const fitsYear = next !== String(thisYear) || Number(month) <= now.getMonth() + 1
          onChange(`${next}-${fitsYear ? month : ''}`)
        }}
        placeholder="Year"
        error={invalid}
        disabled={disabled}
        className="w-full"
      />
    </div>
  )
}
